import { render, staticRenderFns } from "./anchorMonitorItem.vue?vue&type=template&id=a1fbdedc&scoped=true&"
import script from "./anchorMonitorItem.vue?vue&type=script&lang=js&"
export * from "./anchorMonitorItem.vue?vue&type=script&lang=js&"
import style0 from "./anchorMonitorItem.vue?vue&type=style&index=0&id=a1fbdedc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1fbdedc",
  null
  
)

export default component.exports